import { Code, Smartphone, Bot } from 'lucide-vue-next';

export const services = [
  {
    id: 'web',
    title: 'Web Platform Development',
    tagline: 'Scalable digital experiences that drive results',
    description: 'We architect and build high-performance web platforms that serve as the foundation for your digital presence. From customer-facing applications to complex internal systems, our solutions are engineered for scale, security, and exceptional user experience.',
    icon: Code,
    features: [
      'Enterprise-Grade Architecture',
      'Performance Optimization',
      'Advanced Security & Compliance',
      'Scalable Cloud Infrastructure'
    ],
    outcomes: [
      'Increased conversion rates through optimized user journeys',
      'Reduced operational costs via automation',
      'Enhanced user engagement and retention',
      'Future-proof technology stack'
    ]
  },
  {
    id: 'app',
    title: 'Mobile Application Development',
    tagline: 'Native experiences that users love',
    description: 'We create sophisticated mobile applications that deliver seamless experiences across iOS and Android. Whether you need a consumer-facing app or an enterprise solution, we combine intuitive design with robust architecture to build applications that scale with your business.',
    icon: Smartphone,
    features: [
      'Native iOS & Android Development',
      'Cross-Platform Solutions',
      'Offline-First Architecture',
      'Real-Time Synchronization'
    ],
    outcomes: [
      'Higher user engagement and daily active users',
      'Streamlined business operations on mobile',
      'Expanded market reach across platforms',
      'Reduced time-to-market for new features'
    ]
  },
  {
    id: 'ai',
    title: 'AI & Intelligent Automation',
    tagline: 'Transform operations with intelligent systems',
    description: 'We design and implement AI-powered solutions that automate complex workflows, enhance decision-making, and unlock new capabilities for your organization. From natural language processing to predictive analytics, we leverage cutting-edge AI to create competitive advantages.',
    icon: Bot,
    features: [
      'Custom AI Model Development',
      'Natural Language Processing',
      'Predictive Analytics & Insights',
      'Process Automation & Optimization'
    ],
    outcomes: [
      'Significant reduction in manual processing time',
      'Improved accuracy and consistency in operations',
      'Data-driven insights for strategic decisions',
      'Enhanced customer experience through personalization'
    ]
  }
];
